/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getLandApplicationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_APPLICATIONS,
    '/api/v1/rpt/administrator/land/land_applications',
    payload,
    callback
  );

export const getSingleLandApplication = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_APPLICATION,
    `/api/v1/rpt/administrator/land/land_applications/${id}`,
    payload,
    callback
  );

export const createLandApplication = (payload, callback) =>
  req.create(
    c.CREATE_LAND_APPLICATION,
    '/api/v1/rpt/administrator/land/land_applications/',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandApplication = (id, payload, callback) =>
  req.update(
    c.UPDATE_LAND_APPLICATION,
    `/api/v1/rpt/administrator/land/land_applications/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getLandAppraisalList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals`,
    payload,
    callback
  );

export const getSingleLandAppraisal = (
  id,
  landAppraisalId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landAppraisalId}`,
    payload,
    callback
  );

export const createLandAppraisal = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandAppraisal = (id, landAppraisalId, payload, callback) =>
  req.update(
    c.UPDATE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landAppraisalId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandAppraisal = (id, landAppraisalId, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landAppraisalId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getHistoryAppraisalList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_history_logs/${id}/land_appraisal`,
    payload,
    callback
  );

export const getSingleHistoryAppraisal = (
  id,
  landAppraisalId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_LAND_APPRAISAL,
    `/api/v1/rpt/administrator/land/land_history_logs/${id}/land_appraisal/${landAppraisalId}`,
    payload,
    callback
  );

export const getLandPropertyAssessmentList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments`,
    payload,
    callback
  );

export const getSingleLandPropertyAssessment = (
  id,
  landPropertyAssessmentId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    callback
  );

export const createLandPropertyAssessment = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandPropertyAssessment = (
  id,
  landPropertyAssessmentId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandPropertyAssessment = (
  id,
  landPropertyAssessmentId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getHistoryPropertyAssessmentList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_history_logs/${id}/land_property_assessments`,
    payload,
    callback
  );

export const getSingleHistoryPropertyAssessment = (
  id,
  landPropertyAssessmentId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_LAND_PROPERTY_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_history_logs/${id}/land_property_assessments/${landPropertyAssessmentId}`,
    payload,
    callback
  );

export const getLandMarketValueList = (id, marketValueId, payload, callback) =>
  req.list(
    c.GET_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${marketValueId}/land_market_values`,
    payload,
    callback
  );

export const getSingleLandMarketValue = (
  id,
  landMarketValueId,
  marketValueId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landMarketValueId}/land_market_values/${marketValueId}`,
    payload,
    callback
  );

export const createLandMarketValue = (
  id,
  landMarketValueId,
  payload,
  callback
) =>
  req.create(
    c.CREATE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landMarketValueId}/land_market_values`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandMarketValue = (
  id,
  landMarketValueId,
  marketValueId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landMarketValueId}/land_market_values/${marketValueId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandMarketValue = (
  id,
  landMarketValueId,
  marketValueId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_appraisals/${landMarketValueId}/land_market_values/${marketValueId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getHistoryMarketValueList = (
  id,
  marketValueId,
  payload,
  callback
) =>
  req.list(
    c.GET_LAND_MARKET_VALUE,
    `/api/v1/rpt/administrator/land/land_history_logs/${id}/land_appraisal/${marketValueId}/land_market_values`,
    payload,
    callback
  );

export const getAdjustmentFactorList = (payload, callback) =>
  req.list(
    c.GET_ADJUSTMENT_FACTOR_LIST,
    'api/v1/rpt/administrator/land/settings/land_adjustment_factors',
    payload,
    callback
  );

export const getLandRecordofSupAssessmentList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments`,
    payload,
    callback
  );

export const getSingleLandRecordofSupAssessment = (
  id,
  landRecordofSupAssessmentId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments/${landRecordofSupAssessmentId}`,
    payload,
    callback
  );

export const createLandRecordofSupAssessment = (id, payload, callback) =>
  req.create(
    c.CREATE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandRecordofSupAssessment = (
  id,
  landRecordofSupAssessmentId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments/${landRecordofSupAssessmentId}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandRecordofSupAssessment = (
  id,
  landRecordofSupAssessmentId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_record_of_sup_assessments/${landRecordofSupAssessmentId}`,
    payload,
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );
export const getHistoryRecordofSupAssessmentList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_history_logs/${id}/land_record_of_sup_assessments`,
    payload,
    callback
  );

export const getSingleHistoryRecordofSupAssessment = (
  id,
  landRecordofSupAssessmentId,
  payload,
  callback
) =>
  req.item(
    c.GET_SINGLE_LAND_RECORD_OF_SUP_ASSESSMENT,
    `/api/v1/rpt/administrator/land/land_history_logs/${id}/land_record_of_sup_assessments/${landRecordofSupAssessmentId}`,
    payload,
    callback
  );
export const getLandTransactionList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_TRANSACTION,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_transactions`,
    payload,
    callback
  );

export const getPaidLandTransactionList = (id, payload, callback) =>
  req.list(
    c.GET_PAID_LAND_TRANSACTION,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_transactions?is_paid=0`,
    payload,
    callback
  );

export const getHistoryTransactionList = (id, payload, callback) =>
  req.list(
    c.GET_LAND_TRANSACTION,
    `/api/v1/rpt/administrator/land/land_history_logs/${id}/land_transactions`,
    payload,
    callback
  );

export const getSingleHistoryTransaction = (
  id,
  transactionId,
  payload,
  callback
) =>
  req.list(
    c.GET_SINGLE_LAND_TRANSACTION,
    `/api/v1/rpt/administrator/land/land_history_logs/${id}/land_transactions/${transactionId}`,
    payload,
    callback
  );

export const getLandClassificationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATIONS,
    'api/v1/rpt/administrator/land/settings/land_classifications',
    payload,
    callback
  );

export const getSingleLandClass = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_CLASS,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}`,
    payload,
    callback
  );

export const getActualUseList = (payload, callback) =>
  req.list(
    c.GET_ACTUAL_USES,
    'api/v1/rpt/administrator/settings/actual_uses',
    payload,
    callback
  );

export const getTransactionCodesList = (payload, callback) =>
  req.list(
    c.GET_TRANSACTION_CODES,
    'api/v1/rpt/administrator/settings/transaction_codes',
    payload,
    callback
  );

export const getLandOwnerList = (payload, callback) =>
  req.list(
    c.GET_LAND_OWNER,
    'api/v1/rpt/administrator/land/land_owners',
    payload,
    callback
  );

export const getSingleLandOwner = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_OWNER,
    `api/v1/rpt/administrator/land/land_owners/${id}`,
    payload,
    callback
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    'api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    'api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    'api/v1/rpt/administrator/settings/barangays',
    payload,
    callback
  );

export const cancelPost = (id, payload, callback) =>
  req.create(
    c.CANCEL_LAND_POSTING,
    `/api/v1/rpt/administrator/land/land_applications/${id}/cancel_posting`,
    payload,
    callback
  );

export const postApplication = (id, callback) =>
  req.create(
    c.POST_LAND_APPLICATION,
    `/api/v1/rpt/administrator/land/land_applications/${id}/post`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const revertApplication = (id, callback) =>
  req.create(
    c.REVERT_LAND_APPLICATION,
    `/api/v1/rpt/administrator/land/land_applications/${id}/revert`,
    {},
    ({ res }) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Reverted!');
      if (callback) callback();
    }
  );

export const getPaymentHistoryList = (id, payload, callback) =>
  req.list(
    c.GET_PAYMENT_HISTORY,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_transaction_payments`,
    payload,
    callback
  );

export const getCodedValueList = (payload, callback) =>
  req.list(
    c.GET_CODED_VALUE_LIST,
    '/api/v1/rpt/administrator/settings/tax_exempt_codes?status=1',
    payload,
    callback
  );

export const getTdn = (payload, callback) =>
  req.item(
    c.GET_TDN,
    `/api/v1/rpt/administrator/land/tdn`,
    ({ res }) => {
      const { data } = res;
      if (callback) callback({ data });
    },
    payload
  );

export const manualPosting = (id, payload, callback) =>
  req.create(
    c.MANUAL_POSTING,
    `/api/v1/rpt/administrator/land/land_applications/${id}/land_transaction_payments/manual_post`,
    payload,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getPin = (payload, callback) =>
  req.item(
    c.GET_PIN,
    `/api/v1/rpt/administrator/land/pin`,
    ({ res }) => {
      const { data } = res;
      if (callback) callback({ data });
    },
    payload
  );

export const getLandSubClassificationList = (
  landApplicationId,
  payload,
  callback
) =>
  req.list(
    c.GET_LAND_SUB_CLASSIFICATIONS,
    `/api/v1/rpt/administrator/land/land_applications/${landApplicationId}/sub_classifications`,
    payload,
    callback
  );

export const getLocationList = (payload, callback) =>
  req.list(
    c.GET_LOCATION_LIST,
    'api/v1/rpt/administrator/settings/locations',
    payload,
    callback
  );

export const getDistrictList = (payload, callback) =>
  req.list(
    c.GET_DISTRICTS,
    'api/v1/rpt/administrator/settings/districts',
    payload,
    callback
  );

export const createChangeApplication = (payload, callback) =>
  req.create(
    c.CREATE_CHANGE_APPLICATION,
    '/api/v1/rpt/administrator/land/land_applications/change',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getSingleLandSubClass = (rptax_land_buv_id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_SUB_CLASS,
    `/api/v1/rpt/administrator/land/settings/land_basic_unit_values/${rptax_land_buv_id}`,
    payload,
    callback
  );

export const findTdn = (payload, callback) =>
  req.create(
    c.FIND_TDN,
    '/api/v1/rpt/administrator/land/land_applications/search_tdn',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getLogs = (id, payload, callback) =>
  req.list(
    c.GET_LOGS,
    `/api/v1/rpt/administrator/land/land_applications/${id}/logs`,
    payload,
    callback
  );

export const getSubClassificationList = (id, payload, callback) =>
  req.list(
    c.GET_SUBCLASSIFICATION_LIST,
    `/api/v1/rpt/administrator/land/land_applications/${id}/sub_classifications`,
    payload,
    callback
  );

export const getPersonOfConcernList = (payload, callback) =>
  req.list(
    c.GET_PERSON_OF_CONCERN,
    'api/v1/rpt/administrator/land/settings/land_person_of_concern',
    payload,
    callback
  );

export const getEffectivityDateTransfer = (id, payload, callback) =>
  req.list(
    c.GET_EFFECTIVITY_TRANSFER,
    `api/v1/rpt/administrator/land/land_applications/${id}/effectivity_periods`,
    payload,
    callback
  );
  
  export const getTaxEffectivityPeriods = (id, payload, callback) =>
    req.list(
      c.GET_TAX_EFFECTIVITY_PERIOD,
      `api/v1/rpt/administrator/land/land_applications/${id}/tax_effectivity_periods`,
      payload,
      callback
    );
  